// extracted by mini-css-extract-plugin
module.exports = {"owners":"owners__fTXPk","owner":"owner__1bvb_"};